import React from 'react';
import PropTypes from 'prop-types';
import { Controller, useFormContext } from "react-hook-form";
import ErrorMessage from './ErrorMessage';

const TextAreaInput= ({name, placeholder}) => {
  const { control} = useFormContext()

  return (
    <Controller
      name={name}
      control={control}
      render={({
        field, //{ onChange, onBlur, value, name, ref }
        fieldState: { invalid, isTouched, isDirty, error },
        formState,
      }) => (
        <div className="mb-3">
          <div className="form-floating">
            <textarea
              {...field}
              id={field.name}
              style={{height: "160px"}} // Bootstrap Docs: To set a custom height on your <textarea>, do not use the rows attribute. Instead, set an explicit height (either inline or via custom CSS).
              className={`form-control ${isTouched && invalid ? "is-invalid" : ""}`}
              placeholder={placeholder} 
            />
            <label htmlFor={field.name}>{placeholder}</label>
          </div>
          <ErrorMessage error={error}/>
        </div>
      )}
    />
  )
}

TextAreaInput.defaultProps = {};

TextAreaInput.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  type: PropTypes.string,
};

export default TextAreaInput;